<template>
  <div id="offerApply" class="pr">
    <!-- <transition name="bg-change" mode="out-in"> -->
    <div
      class="offer-applied-message fs-11 lh16 flex-row"
      v-if="$store.state.Offers.selectedOfferIndex !== -1"
      :class="{
        bottom0: cartQuantity === 0 && source === 'menu-page',
      }"
      @click="triggerTncModal($event, selectedOfferIndex)"
    >
      <div class="flex-row align-items-center">
        <img
          :src="staticImgBaseUrl + '/images/global/offer-percentage.svg'"
          class="pd12 pr10"
        />
        <div class="flex-column">
          <h4 class="ellips">{{ message }}</h4>
          <h4 class="bold" v-if="cartTotal && cartTotal !== '0'">
            Cart total: <span>{{ currencySymbol }}</span>{{ cartTotal }} + taxes
          </h4>
        </div>
      </div>
      <div class="mr20 hand-cursor">
        <i class="jfi-arrow-line ml7"></i>
      </div>
    </div>
    <!-- </transition> -->
    <!-- Offer applied message popup -->
    <generic-modal
      v-if="showTncModalFromStore"
      @close="closeTncModal('dismiss')"
      :height="msModalDim.height"
      :width="msModalDim.width"
      :animationStyle="msModalDim.animationStyle"
      :genericModalSource="'welcomeOfferDetail'"
      :removePaddingExtra="removePaddingExtra"
    >
      <template v-slot:header>
        <i
          @click="closeTncModal('cross')"
          class="jfi-cross sticky-pop-cross"
        ></i>
      </template>
      <template v-slot:body>
        <div class="ms-offer-pop-content">
          <div class="logo-box mb10">
            <div class="logo-sm-img"></div>
          </div>
          <div class="fs-18 bold mb15">
            {{ welcomeOffers[selectedOfferIndex]?.text }}
          </div>
          <ul
            class="fs-14 bold disp-col-inline ms-timeline"
            v-if="welcomeOffers[selectedOfferIndex]?.milestonesCouponDTOList"
          >
            <li
              v-for="(mileStoneItem, i) in welcomeOffers[selectedOfferIndex]
                ?.milestonesCouponDTOList"
              :key="i"
            >
              <div class="bold order-no color-grey">
                {{ i + 1 }}{{ nth(i + 1) }} Order
              </div>
              <div class="fs-12 bold color-green">
                {{ mileStoneItem.title }}
              </div>
              <div class="border-arrow-img-grey"></div>
            </li>
          </ul>
          <div class="offer-state">
            <!-- tobe shown when coupan code is applied -->
            <div class="code-applied-dets disp-col-inline">
              <span
                >Code
                {{ welcomeOffers[selectedOfferIndex].promoCode }} applied!</span
              >
              <span
                class="bold remove-code"
                @click="removeCouponCode($event, selectedOfferIndex)"
                >Remove</span
              >
            </div>
          </div>
          <div class="ms-offer-details">
            <h3 class="bold">Offer Details:</h3>
            <ul class="disc-styled mt10 color-grey fs-11">
              <li
                class="lh16 mb5"
                v-for="tncItem in selectedOfferTnc"
                :key="tncItem"
              >
                {{ tncItem }}
              </li>
            </ul>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal>
  </div>
</template>

<script>
import GenericModal from "./GenericModal.vue";
import {
  keyMapsAction,
  keyMapsGetter,
  keyMapsMutation,
} from "../helpers/storeKeys";
import { staticImgBaseUrl } from "../config/apiEndpoints";
import LocalStorageFunc from "../helpers/localStorageFunc";
import Utility from "../helpers/utility";
import setEvents from "../helpers/events";
import { CURRENCY_SYMBOL } from "../helpers/paymentConstants";

export default {
  name: "OfferAppliedMessage",
  props: ["source", "removePaddingExtra"],

  components: {
    GenericModal,
  },

  data() {
    return {
      showTncModal: false,
      msModalDim: {
        width: "100vw",
        height: "calc(91vh - 56px)",
        animationStyle: "slide-up-stick-bottom",
        modalClass: "modal-bg-blackout",
      },
      staticImgBaseUrl: staticImgBaseUrl,
      isImpressionProcessed: {},
      currencySymbol: CURRENCY_SYMBOL,
    };
  },
  mounted() {
    let addZindex = document.getElementById("offerApply");
    // addZindex && addZindex.classList.add("z-index-offer-applied");
  },
  methods: {
    eventFunction(isClicked = false, eObj, index) {
      let preEventObj = {};
      let eventType = isClicked ? "Click" : "nghOfferImpression";
      let userAction = isClicked ? "click" : "impression";
      if (this.welcomeOffers[index]?.type == "MILESTONE") {
        preEventObj = {
          offerType: "milestone",
          milestoneStage: Utility.getMilestoneStage(this.welcomeOffers[index]),
          ...eObj,
        };
      } else {
        preEventObj = {
          offerType:
            this.welcomeOffers[index]?.couponDetail?.templatePrefix ==
            "fixDiscount"
              ? "flat discount"
              : "percentage discount",
          ...eObj,
        };
      }
      preEventObj["category"] = this.welcomeOffers[index]?.title?.toLowerCase();
      preEventObj["positionWithinSection"] = index + 1;

      const eventObj = Utility.amplitudeEventObj(
        userAction,
        "offer section",
        "12",
        preEventObj,
      );
      setEvents("amplitude", eventType, eventObj);
    },
    nth(n) {
      return ["st", "nd", "rd"][((((n + 90) % 100) - 10) % 10) - 1] || "th";
    },
    removeCouponCode() {
      //Amplitude Click event load
      this.eventFunction(
        true,
        {
          offerStage: "applied",
          actionType: "remove",
          subCategory: this.popupSource,
        },
        this.selectedOfferIndex,
      );

      if (
        this.welcomeOffers[this.selectedOfferIndex]?.paymentOptions?.filter(
          (_) => _.paymentId == "CC",
        )?.length > 0 &&
        LocalStorageFunc.getPaymentOfferPaymentIdLS() == "CC"
      ) {
        LocalStorageFunc.updatePaymentOfferpaymentId({});
      }

      this.$store.commit(keyMapsMutation.UPDATE_SELECTED_OFFER_INDEX, -1);
      LocalStorageFunc.updateCouponCode();
      const isCouponAppliedFromOffersPage =
        sessionStorage.isCouponAppliedFromOffersPage == "true";
      if (isCouponAppliedFromOffersPage) {
        LocalStorageFunc.unsetSessionStorageKey(
          "isCouponAppliedFromOffersPage",
        );
      }

      this.closeTncModal();
      this.$store.commit(keyMapsMutation.UPDATE_OFFER_APPLY_MODAL_KEY, false);
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_TNC_MODAL, false);
      let addZindex = document.getElementById("offerApply");
      addZindex.classList.remove("z-index-offer-applied");
    },
    triggerTncModal(event, index) {
      if (!this.isImpressionProcessed[this.selectedOfferIndex + 1]) {
        this.isImpressionProcessed[this.selectedOfferIndex + 1] = true;
      }

      document.body.classList.add("body-stop-scroll-mobile");
      this.showTncModal = true;
      this.$store.commit(
        keyMapsMutation.UPDATE_OFFFER_POPUP_SOURCE,
        "bottom strip",
      );
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_TNC_MODAL, true);
      const { promoCode } = this.welcomeOffers[index];
      this.$store.commit(keyMapsMutation.UPDATE_SELECTED_OFFER_TNC, []);
      promoCode &&
        this.$store.dispatch(keyMapsAction.OFFER_TNC_API, {
          promoCode: promoCode,
        });

      this.eventFunction(
        true,
        {
          offerStage: "applied",
          subCategory: "bottom strip",
        },
        this.selectedOfferIndex,
      );
    },
    closeTncModal(source) {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.showTncModal = false;
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_TNC_MODAL, false);
      if (source) {
        //Amplitude Click event load
        this.eventFunction(
          true,
          {
            offerStage: "applied",
            actionType: source == "cross" ? "cross tap" : "default dismiss",
            subCategory: this.popupSource,
          },
          this.selectedOfferIndex,
        );
      }
    },
  },
  computed: {
    message() {
      if (this.welcomeOffers?.[this.selectedOfferIndex]?.nudgeMessage) {
        return this.welcomeOffers[this.selectedOfferIndex].nudgeMessage;
      } else {
        return "Offer applied! Add items and proceed to your cart";
      }
    },
    cartTotal() {
      return this.$store.getters[keyMapsGetter.CART_TOTAL];
    },
    cartQuantity() {
      return this.$store.getters[keyMapsGetter.CART_QUANTITY];
    },
    welcomeOffers() {
      return this.$store.state.Offers.welcomeOffers;
    },
    selectedOfferIndex() {
      return this.$store.state.Offers.selectedOfferIndex;
    },
    selectedOfferTnc() {
      return this.$store.state.Offers.selectedOfferTnc;
    },
    showTncModalFromStore() {
      let _ = this.$store.state.Offers.showTncModal;
      if (_ && !this.isImpressionProcessed[this.selectedOfferIndex + 1]) {
        this.isImpressionProcessed[this.selectedOfferIndex + 1] = true;
        this.eventFunction(
          false,
          {
            offerStage: "applied",
          },
          this.selectedOfferIndex,
        );
      }
      return _;
    },
    popupSource() {
      return this.$store.state.Offers.popupSource;
    },
  },
};
</script>
